var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStopCircle = function SvgStopCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 1.667,
    d: "M1.279 12c0-5.983 4.85-10.833 10.833-10.833S22.945 6.017 22.945 12a10.807 10.807 0 0 1-2.889 7.365 10.8 10.8 0 0 1-7.944 3.468c-5.13 0-9.428-3.565-10.548-8.354A11 11 0 0 1 1.279 12Z"
  })));
};
export default SvgStopCircle;